import React, { useState, useEffect } from 'react';
import { Button, Col, Modal, Row, Alert } from 'antd';
import { StatusScreen } from '@mercadopago/sdk-react';
import { FilePdfOutlined } from '@ant-design/icons';

const EstatusScreen = (props) => {

    const {verEstatusScreen, informacionCompra, setverPaseMedico } = props;
    const [initialization, setinitialization] = useState({});
    const [verBotonPaseMedico, setverBotonPaseMedico] = useState(false);

    useEffect(() => {
        if (verEstatusScreen === true) {
            console.log(informacionCompra, "informacionCompra");
            setinitialization({
                paymentId: informacionCompra?.data?.id, // id de pago para mostrar
            });
            if (informacionCompra?.data?.status === 'approved') {
                setverBotonPaseMedico(true);
            }

        }
    }, [verEstatusScreen, informacionCompra]);

    const mostrarModalPaseMedico = () => {
        setverPaseMedico(true);
    }

    return (
        <Modal open={verEstatusScreen} title={<><h3 style={{ fontSize: '1.5vw', margin: 0 }}>Estatus del pago:</h3></>} closeIcon={<></>}
            footer={<Row gutter={16}>

                <Col
                    span={24} style={{ marginTop: "2%" }}><Button disabled={verBotonPaseMedico} type="default" size='large' block>Regresar</Button></Col>
            </Row>}
        >
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Alert
                            description="La información que nos proporciones sea validada por uno de nuestros agentes."
                            type="warning"
                            showIcon
                        />
                    </Col>
                    <Col span={24}>&nbsp;</Col>
                    <Col span={24}>
                        {
                            initialization && initialization.paymentId != null &&
                            <StatusScreen
                                initialization={initialization}
                            />
                        }
                        <Button disabled={!verBotonPaseMedico} icon={<FilePdfOutlined />} size='large' type='primary' onClick={(e) => mostrarModalPaseMedico()} block >Ver pase medico</Button>

                    </Col>
                </Row>

            </div>
        </Modal>
    )
}

export default EstatusScreen
